import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import InputField from "../InputField/InputField";
import * as Yup from "yup";

import { Formik } from "formik";
import './ForgotPassword.styles.css';
import { Flip, Slide, toast } from 'react-toastify';
import * as Axios from "../../services/auth";
import { useNavigate } from 'react-router-dom';

const CorporateformSchema = Yup.object().shape({
  username: Yup.string().required("Username is required"),
});

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [initialValue, setInitialValue] = useState({
    username: ""
  });

  const FormSubmitHandler = async (values) => {
    const url = "accounts/forgot-password"
    const val = {
      // email: values.email,
      username: values.username.toLowerCase(),
    }
    const response = await Axios.commonPost(val, url);
    if(response?.status==200){
      var message = response.data.message ?? 'Password Reset Successfull';
      toast.success(message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Slide,
      });
      navigate('/login');
    }
    else {
      toast.error('Your email or username does not exist.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Flip,
      })
    }
  }

  return (
    <section className="main-container col1-layout">
      <Container className="main">
        <Row className='justify-content-center'>
          <Col xs={12} sm={6} lg={12}>
            <div className="account-login">
              <div className="page-title">
                <h2>Forgot Password</h2>
              </div>
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformSchema}
                onSubmit={(values, { setSubmitting }) => {
                  FormSubmitHandler(values);
                  setSubmitting(false);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="col-1 registered-users">
                      <p>Send a link to your email to reset your password</p>
                      <div className="content">
                        <div className="form-list">
                          <Row>
                            <Col sm={6}>
                            <InputField
                                Name="username"
                                id="username"
                                Labels="Username"
                                Type="text"
                                value={values.username}
                                onChange={handleChange}
                                isInvalid={!!errors.username}
                                className={(errors.username && touched.username) ? 'is-invalid' : 'form-control'}
                              // onBlur={handleBlur}

                              // error={errors.firstName && touched.firstName && errors.firstName}
                              />
{/* 
                              <InputField
                                Name="email"
                                id="email"
                                Labels="Email Address"
                                Type="text"
                                value={values.email}
                                onChange={handleChange}
                                isInvalid={!!errors.email}
                                className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                              // onBlur={handleBlur}

                              // error={errors.firstName && touched.firstName && errors.firstName}
                              /> */}

                              <button
                                id="send2"
                                name="send"
                                type="submit"
                                className="button login"
                              >
                                <span>Send Reset Link</span>
                              </button>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>

                  </form>
                )}
              </Formik>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ForgotPassword;
